import { MarketCriteriaItem } from '../Components/Screener/Criteria/MarketCriteria/MarketCriteria';
import { DropdownItemType, SectorType } from '../types/common.type';

export const MarketList: DropdownItemType[] = [
  { label: 'USA', value: 'USA' },
  { label: 'Australia', value: 'AUS' },
];

export const errorMsg = [
  { key: 'noDataMsg', label: 'No data available' },
  { key: 'noNewMsg', label: 'No news available' },
  { key: 'balanceSheet', label: 'No balance sheet information' },
  { key: 'brokerRating', label: 'No broker ratings' },
  { key: 'cashFlow', label: 'No cash flow information' },
  { key: 'chart', label: 'Chart is currently unavailable' },
  { key: 'companyEvents', label: 'No company events' },
  { key: 'companyDirectors', label: 'No company directors information' },
  { key: 'companyProfile', label: 'No company profile information' },
  { key: 'companyScore', label: 'No company score' },
  {
    key: 'consensusRecommendations',
    label: 'This content in currently unavailable',
  },
  { key: 'dividends', label: 'No dividend information' },
  { key: 'heatmap', label: 'Heatmap is currently unavailable' },
  { key: 'keyRatios', label: 'No key ratios information' },
  { key: 'incomeStatement', label: 'No income statement information' },
  { key: 'indexList', label: 'This content in currently unavailable' },
  {
    key: 'indexPerformanceList',
    label: 'This content in currently unavailable',
  },
  { key: 'newsWidgets', label: 'No news available' },
  { key: 'ownership', label: 'No ownership information' },
  { key: 'peerComparison', label: 'Peer comparison unavailable' },
  { key: 'priceHistory', label: 'No price history' },
  { key: 'sentiment', label: 'No sentiment score' },
  { key: 'stockScreener', label: 'Stock screener is currently unavailable' },
  { key: 'topMovers', label: 'Top movers currently unavailable' },
  { key: 'TargetPrice', label: 'No target price available' },
  { key: 'fundSummary', label: 'ETF summary currently unavailable' },
  { key: 'fundScreener', label: 'Fund screener no results found' },
];
export const defaultPageNum = 5;
